<template>
  <Accordion :title="name" class="container">
    <div class="desktop:text-xl" v-html="answer" />
    <ZtLink
      v-if="link && link.title"
      :to="link.url?.path"
      class="link with-arrow mt-size-7"
    >
      {{ link.title }}
    </ZtLink>
  </Accordion>
</template>

<script setup lang="ts">
import type { StorageFaqFragment } from '#graphql-operations'
defineProps<{
  id?: StorageFaqFragment['id']
  name?: StorageFaqFragment['name']
  answer?: StorageFaqFragment['answer']
  link?: StorageFaqFragment['link']
}>()
</script>

<style scoped></style>
